import { configureStore } from "@reduxjs/toolkit";
import LoginReducer from "./reducers/account_reducer";
import MenuReducer from "./reducers/menu_reducer";

export default configureStore({
  reducer: {
    account: LoginReducer,
    menu: MenuReducer,
  },
});